import { render, staticRenderFns } from "./NewLeadText.vue?vue&type=template&id=06cba646"
import script from "./NewLeadText.vue?vue&type=script&lang=js"
export * from "./NewLeadText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports